"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadStatusEnum = exports.BucketStateEnum = void 0;
var BucketStateEnum;
(function (BucketStateEnum) {
    BucketStateEnum["MAINTAINED"] = "MAINTAINED";
    BucketStateEnum["ARCHIVED"] = "ARCHIVED";
})(BucketStateEnum || (BucketStateEnum = {}));
exports.BucketStateEnum = BucketStateEnum;
var UploadStatusEnum;
(function (UploadStatusEnum) {
    UploadStatusEnum["IN_PROGRESS"] = "InProgress";
    UploadStatusEnum["CANCELED"] = "Canceled";
    UploadStatusEnum["UPLOADED"] = "Uploaded";
    UploadStatusEnum["FAILED"] = "Failed";
    UploadStatusEnum["TIMED_OUT"] = "TimedOut";
    UploadStatusEnum["PINNED"] = "Pinned";
    UploadStatusEnum["UNPINNED"] = "Unpinned";
})(UploadStatusEnum || (UploadStatusEnum = {}));
exports.UploadStatusEnum = UploadStatusEnum;
